'use client'

import { FC } from 'react'
import { X } from 'lucide-react'

import { Button, ButtonProps } from '../button'
import { usePopoverContext } from './popover'

export const PopoverClose: FC<ButtonProps> = ({ onClick, ref, ...props }) => {
  const { setOpen } = usePopoverContext()
  return (
    <Button
      buttonShape="square"
      buttonType="transparent"
      ref={ref}
      {...props}
      onClick={event => {
        onClick?.(event)
        setOpen(false)
      }}
      leftIconSlot={<X />}
    />
  )
}
